<template>
<div class="fpui-table_tr">
  <div
    class="fpui-table_th"
    v-for="(column, idx) in columns"
    :key="`th-clm-${idx}`"
    :class="{ 'sortable': !!column.sortable, 'sort-active': sort.sortOn?.name === column.name, first:idx === 0 }"
    @click="sortColumn(column)"
    :style="column.cellStyle"
  >
    <component
      :is="getComponent(column)"
      v-bind='getBind(column)'
      v-on='getEvents(column)'
      :key="idx"
      :column="column"
    />
    <fpui-icon
      v-if="column.sortable"
      :name="getIconName(column)"
      :size="16"
      class="sort-icon"
    />
  </div>
</div>
</template>
<script>
import FpuiTableHeaderCell from './FpuiTableHeaderCell'
import FpuiIcon from '@/shared/components/icons/FpuiIcon.vue'
export default {
  components: {
    FpuiIcon
  },
  props: {
    columns: { type: Array, default: () => [] },
    sort: {
      type: Object,
      default: () => ({
        sortOn: '',
        reverse: false
      })
    }
  },
  methods: {
    getComponent (column) {
      if (column.headerComponent) return column.headerComponent
      return FpuiTableHeaderCell
    },
    getBind (column) {
      if (column.headerComponent) {
        return column.headerProps ?? null
      }
      return null
    },
    getEvents (column) {
      if (column.headerComponent && column.headerEvents) {
        return Object.fromEntries(
          Object.entries(column.headerEvents).map(([eventName, eventFunction]) => [
            eventName,
            value => eventFunction(value, this.column)
          ])
        )
      }
      return {}
    },
    /**
     * Returns the icon name based on the column sort state
     * @param {object} column
     * @returns {string}
     */
    getIconName (column) {
      if (this.sort.sortOn?.name === column.name) {
        return this.sort.reverse ? 'ChevronDown' : 'ChevronUp'
      }
      return 'ChevronsUpDown'
    },
    /**
     * Returns the icon color based on the column sort state
     * @param {object} column
     * @returns {string}
     */
    getIconColor (column) {
      if (this.sort.sortOn?.name === column.name) {
        return '#0089c0' // @blue
      }
      return 'currentColor'
    },
    /**
   * Sorts the column from the parameter. To use with the sort functionality
   * @param {object} column
   */
    sortColumn (column) {
      if (!column.sortable) return
      this.$emit('sortEvent', column)
    }
  }
}
</script>
<style lang="less">
</style>
